import React from 'react';

const Icon = () => (
  <svg width="8" height="13" viewBox="0 0 8 13" fill="none">
    <path
      d="M1.70687 0.5L0.296875 1.91L4.87687 6.5L0.296875 11.09L1.70687 12.5L7.70687 6.5L1.70687 0.5Z"
      fill="#502314"
    />
  </svg>
);

export const ArrowIcon = Icon;
